import React from 'react'
import Helmet from 'react-helmet'
import jump from 'jump.js'

import { Header } from 'src/components/header'
import { Footer } from 'src/components/footer'
import { SwitchTransition, Transition } from 'react-transition-group'
import { CartDrawer } from 'src/components/cartDrawer'
import { PageLink } from 'src/components/link'
import { PasswordWrapper } from './password'

const TRANSITION_DURATION = 400;
const TRANSITION_STYLES = {
	default: {
		transition: `opacity ${TRANSITION_DURATION}ms ease-in-out`,
	},
	entering: {
		opacity: 0,
	},
	entered: {
		opacity: 1,
	},
	exiting: {
		opacity: 0,
	},
	exited: {
		opacity: 0,
	},
};

import 'src/styles/main.css'

const handleJump = () => {
  const jumpy = document.querySelector('.js-content')
  jump(jumpy, {
    offset: -76
  })
}

const Layout = ({ children, siteMetadata, location }: { children: any }) => {
  return (
    <React.Fragment>
      <Helmet title='USBYUS'>
        <html lang='en' />
      </Helmet>
        <div className='rel caps'>
          
          <CartDrawer />
          {/* 
          
            Smooth transition credits to Ian Williams: https://github.com/dictions
          
          */}
          {!/account/.test(location.pathname) ? (
            <SwitchTransition>
              <Transition
                key={location.pathname}
                mountOnEnter
                unmountOnExit
                appear
                timeout={TRANSITION_DURATION}>
                  {status => (
                    <div className={location.pathname.replace(/\//g, " ")}
                      style={{
                        ...TRANSITION_STYLES.default,
                        ...TRANSITION_STYLES[status],
                      }}>
                      {location.pathname === '/' && (
                        <div className='header__top header--blewp'>
                          <div className='container--xl mxa px1 pt05 outer'>
                            <div className='f x jcb aic'>
                              <div>
                                <PageLink to='/about' className=' s1 m0 p0 caps'>About</PageLink>
                              </div>
                              <div>
                                <button onClick={() => handleJump()} className='m0 p0 s1 button h-underline caps'>Shop</button>
                              </div>
                            </div>
                          </div>
                          <div className='header__fine ac'>
                            <span className='caps s1 '>Fine Art <span>for</span> Fine People</span>
                          </div>
                          <div className='x ac header__title'>
                            <h1 className='display a-black'>US<span>BY</span>US</h1>
                          </div>
                        </div>
                      )}
                      <Header {...location} />
                      <div className='js-content'>
                        {children}
                      </div>
                      <Footer />
                    </div>
                  )}
              </Transition>
            </SwitchTransition>
          ) : (
            <div>
              {children}
              <Footer />
            </div>
          )}
        </div>
    </React.Fragment>
  )
}

export default Layout